const DEFAULT_MUTELU_JOIN_PATH = '/game/mutelu/party-join'

export const buildMuteluPartyJoinShareUrl = (groupCode = '') => {
  const safeCode = String(groupCode || '').trim()
  const joinPath = safeCode
    ? `${DEFAULT_MUTELU_JOIN_PATH}/${encodeURIComponent(safeCode)}`
    : DEFAULT_MUTELU_JOIN_PATH

  return `${window.location.origin}${joinPath}`
}

export default buildMuteluPartyJoinShareUrl
